import { useRef, useCallback } from 'react';

interface UseContentEditableProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
}

export const useContentEditable = ({ value, onChange, onKeyDown }: UseContentEditableProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleInput = useCallback((e: React.FormEvent<HTMLDivElement>) => {
    const content = e.currentTarget.textContent || '';
    onChange(content);
  }, [onChange]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLDivElement>) => {
    if (onKeyDown) {
      onKeyDown(e);
    }
  }, [onKeyDown]);

  return {
    ref,
    onInput: handleInput,
    onKeyDown: handleKeyDown,
  };
};
